import { SxProps } from '@mui/material'

interface ErrorPageStyles {
  container: SxProps
  contentWrapper: SxProps
  title: SxProps
  text: SxProps
}

export const errorPageStyles: ErrorPageStyles = {
  container: {
    height: '100vh',
    width: '100vw',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'utils.gray950',
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2,
    textAlign: 'center',
    p: 2,
  },
  title: {
    typography: 'textXlSemibold',
    color: 'text.primaryContrast',
  },
  text: {
    typography: 'textMd',
    color: 'text.primaryContrast',
  },
}
